import React from 'react';
import PropTypes from 'prop-types';
export default function FeaturedCharityCard(props) {
  var id = props.id,
    image = props.image,
    email = props.email,
    charity = props.charity,
    website = props.website;
  return /*#__PURE__*/React.createElement("div", {
    className: "m-charity-card block rounded-lg mb-6 border-white border-2 col-span-4 grid grid-cols-2",
    key: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-charity-card__image bg-white p-4 py-12 sm:py-24 md:py-36 text-center col-span-2 sm:col-span-1"
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    className: "inline-block max-h-20 sm:max-h-32 md:max-h-36 w-auto",
    src: image,
    alt: email
  })), /*#__PURE__*/React.createElement("div", {
    className: "m-charity-card-details p-6 relative col-span-2 sm:col-span-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "charity w-full text-xl md:text-6xl font-bold mb-2"
  }, charity), /*#__PURE__*/React.createElement("div", {
    className: "m-charity-card-details__links sm:absolute sm:bottom-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-charity-card-details__website w-full mb-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "visually-hidden"
  }, "Visit the ", charity, " website"), /*#__PURE__*/React.createElement("span", {
    className: "align-top py-1 inline-block pb-2 text-base text-grey-450"
  }, "Website"), /*#__PURE__*/React.createElement("a", {
    title: "website",
    href: website,
    className: "p-2 text-black inline-block ml-4 hover:rounded-3xl focus:rounded-3xl focus:bg-grey-125 hover:bg-grey-125 focus:outline-none"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75 13.75C1.3375 13.75 0.98425 13.6033 0.69025 13.3097C0.39675 13.0157 0.25 12.6625 0.25 12.25V1.75C0.25 1.3375 0.39675 0.98425 0.69025 0.69025C0.98425 0.39675 1.3375 0.25 1.75 0.25H7V1.75H1.75V12.25H12.25V7H13.75V12.25C13.75 12.6625 13.6033 13.0157 13.3097 13.3097C13.0157 13.6033 12.6625 13.75 12.25 13.75H1.75ZM5.275 9.775L4.225 8.725L11.2 1.75H8.5V0.25H13.75V5.5H12.25V2.8L5.275 9.775Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("button", {
    tabIndex: "0",
    className: "p-2 text-black align-super inline-block ml-2 hover:rounded-3xl focus:rounded-3xl focus:bg-grey-125 hover:bg-grey-125 focus:outline-none",
    onClick: function onClick() {
      return navigator.clipboard.writeText("".concat(website));
    }
  }, /*#__PURE__*/React.createElement("svg", {
    fill: "currentColor",
    width: "16",
    height: "16",
    version: "1.1",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 111.07 122.88"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M97.67,20.81L97.67,20.81l0.01,0.02c3.7,0.01,7.04,1.51,9.46,3.93c2.4,2.41,3.9,5.74,3.9,9.42h0.02v0.02v75.28 v0.01h-0.02c-0.01,3.68-1.51,7.03-3.93,9.46c-2.41,2.4-5.74,3.9-9.42,3.9v0.02h-0.02H38.48h-0.01v-0.02 c-3.69-0.01-7.04-1.5-9.46-3.93c-2.4-2.41-3.9-5.74-3.91-9.42H25.1c0-25.96,0-49.34,0-75.3v-0.01h0.02 c0.01-3.69,1.52-7.04,3.94-9.46c2.41-2.4,5.73-3.9,9.42-3.91v-0.02h0.02C58.22,20.81,77.95,20.81,97.67,20.81L97.67,20.81z M0.02,75.38L0,13.39v-0.01h0.02c0.01-3.69,1.52-7.04,3.93-9.46c2.41-2.4,5.74-3.9,9.42-3.91V0h0.02h59.19 c7.69,0,8.9,9.96,0.01,10.16H13.4h-0.02v-0.02c-0.88,0-1.68,0.37-2.27,0.97c-0.59,0.58-0.96,1.4-0.96,2.27h0.02v0.01v3.17 c0,19.61,0,39.21,0,58.81C10.17,83.63,0.02,84.09,0.02,75.38L0.02,75.38z M100.91,109.49V34.2v-0.02h0.02 c0-0.87-0.37-1.68-0.97-2.27c-0.59-0.58-1.4-0.96-2.28-0.96v0.02h-0.01H38.48h-0.02v-0.02c-0.88,0-1.68,0.38-2.27,0.97 c-0.59,0.58-0.96,1.4-0.96,2.27h0.02v0.01v75.28v0.02h-0.02c0,0.88,0.38,1.68,0.97,2.27c0.59,0.59,1.4,0.96,2.27,0.96v-0.02h0.01 h59.19h0.02v0.02c0.87,0,1.68-0.38,2.27-0.97c0.59-0.58,0.96-1.4,0.96-2.27L100.91,109.49L100.91,109.49L100.91,109.49 L100.91,109.49z"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "m-charity-card-details__email w-full"
  }, /*#__PURE__*/React.createElement("span", {
    className: "visually-hidden"
  }, "Send an email to ", charity), /*#__PURE__*/React.createElement("span", {
    className: "align-top py-1 inline-block pb-2 text-base text-grey-450"
  }, "Email"), /*#__PURE__*/React.createElement("a", {
    title: "email",
    href: "mailto:".concat(email),
    className: "p-2 text-black inline-block ml-4 hover:rounded-3xl focus:rounded-3xl focus:bg-grey-125 focus:outline-none hover:bg-grey-125"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75 13.75C1.3375 13.75 0.98425 13.6033 0.69025 13.3097C0.39675 13.0157 0.25 12.6625 0.25 12.25V1.75C0.25 1.3375 0.39675 0.98425 0.69025 0.69025C0.98425 0.39675 1.3375 0.25 1.75 0.25H7V1.75H1.75V12.25H12.25V7H13.75V12.25C13.75 12.6625 13.6033 13.0157 13.3097 13.3097C13.0157 13.6033 12.6625 13.75 12.25 13.75H1.75ZM5.275 9.775L4.225 8.725L11.2 1.75H8.5V0.25H13.75V5.5H12.25V2.8L5.275 9.775Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("button", {
    tabIndex: "0",
    className: "p-2 align-super text-black inline-block ml-2 hover:rounded-3xl focus:rounded-3xl focus:bg-grey-125 hover:bg-grey-125 focus:outline-none",
    onClick: function onClick() {
      return navigator.clipboard.writeText("".concat(email));
    }
  }, /*#__PURE__*/React.createElement("svg", {
    fill: "currentColor",
    width: "16",
    height: "16",
    version: "1.1",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 111.07 122.88"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M97.67,20.81L97.67,20.81l0.01,0.02c3.7,0.01,7.04,1.51,9.46,3.93c2.4,2.41,3.9,5.74,3.9,9.42h0.02v0.02v75.28 v0.01h-0.02c-0.01,3.68-1.51,7.03-3.93,9.46c-2.41,2.4-5.74,3.9-9.42,3.9v0.02h-0.02H38.48h-0.01v-0.02 c-3.69-0.01-7.04-1.5-9.46-3.93c-2.4-2.41-3.9-5.74-3.91-9.42H25.1c0-25.96,0-49.34,0-75.3v-0.01h0.02 c0.01-3.69,1.52-7.04,3.94-9.46c2.41-2.4,5.73-3.9,9.42-3.91v-0.02h0.02C58.22,20.81,77.95,20.81,97.67,20.81L97.67,20.81z M0.02,75.38L0,13.39v-0.01h0.02c0.01-3.69,1.52-7.04,3.93-9.46c2.41-2.4,5.74-3.9,9.42-3.91V0h0.02h59.19 c7.69,0,8.9,9.96,0.01,10.16H13.4h-0.02v-0.02c-0.88,0-1.68,0.37-2.27,0.97c-0.59,0.58-0.96,1.4-0.96,2.27h0.02v0.01v3.17 c0,19.61,0,39.21,0,58.81C10.17,83.63,0.02,84.09,0.02,75.38L0.02,75.38z M100.91,109.49V34.2v-0.02h0.02 c0-0.87-0.37-1.68-0.97-2.27c-0.59-0.58-1.4-0.96-2.28-0.96v0.02h-0.01H38.48h-0.02v-0.02c-0.88,0-1.68,0.38-2.27,0.97 c-0.59,0.58-0.96,1.4-0.96,2.27h0.02v0.01v75.28v0.02h-0.02c0,0.88,0.38,1.68,0.97,2.27c0.59,0.59,1.4,0.96,2.27,0.96v-0.02h0.01 h59.19h0.02v0.02c0.87,0,1.68-0.38,2.27-0.97c0.59-0.58,0.96-1.4,0.96-2.27L100.91,109.49L100.91,109.49L100.91,109.49 L100.91,109.49z"
  }))))))));
}
FeaturedCharityCard.propTypes = {
  id: PropTypes.number,
  image: PropTypes.string,
  email: PropTypes.string,
  charity: PropTypes.string,
  group: PropTypes.string,
  website: PropTypes.string
};